/** Maps a numeric page size to the shape expected by `@tcl-boron-prefabs/pagination`. */
export function intToPageSizeOption(int: number, rowsLabel: string): { value: string; label: string } {
  if (!Number.isInteger(int)) {
    throw new Error(`Number passed to intToPageSizeOption must be an integer but ${int} was passed instead.`);
  }
  return {
    value: int.toString(),
    label: rowsLabel,
  };
}
